import { UserInfo } from '@/types';
import { AccessMasterRolesEnum, BusinessRolesEnum, TechnicalRolesEnum } from '@/types/enum/RoleEnum';
import { hasRolesForProject } from '@/config/plugins/vue-browser-acl';
import { ActionPermissionEnum } from '@/types/enum/PermissionEnum';

export default function setActionPermission(acl: any) {
	acl.rule(ActionPermissionEnum.USER_CREATE, 'User', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(BusinessRolesEnum.ADMIN_LOCAL, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.PROJECT_EDIT, (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.PATIENT_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.PATIENT_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.PATIENT_PCR_ADD, 'Project', (user: UserInfo, project: any) =>
			user && (
				hasRolesForProject(TechnicalRolesEnum.PATIENT_PCR_ADD, user, project)
			)
	);

	acl.rule(ActionPermissionEnum.ADDRESSING_ADD, 'Project', (user: UserInfo, project: any) =>
			user && (
				hasRolesForProject(TechnicalRolesEnum.ADDRESSING_ADD, user, project)
			)
	);

	acl.rule(ActionPermissionEnum.ADDRESSING_DELETE, 'Project', (user: UserInfo, project: any) =>
			user && (
				hasRolesForProject(TechnicalRolesEnum.ADDRESSING_DELETE, user, project)
			)
	);

	acl.rule(ActionPermissionEnum.PATIENT_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.PATIENT_DELETE, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.PATIENT_IDEL_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.IDEL_PATIENT_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.PATIENT_IDEL_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.IDEL_PATIENT_DELETE, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.DATA_LINE_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.DATA_LINE_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.ACTOR_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.ACTOR_ADD, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.ACTOR_EDIT, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.ACTOR_EDIT, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.ACTOR_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.ACTOR_DELETE, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.FILE_STORAGE_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_DELETE, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.FILE_STORAGE_DOWNLOAD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_DOWNLOAD, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.CONTACT_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.CONTACT_DELETE, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.CONTACT_DOWNLOAD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.CONTACT_DOWNLOAD, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.SEARCH_NIR, 'Project', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.SEARCH_NIR, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.IMPORT_DOWNLOAD, 'Project', (user: UserInfo, project: any) =>
		user &&
		hasRolesForProject(TechnicalRolesEnum.IMPORTER_DOWNLOAD, user, project)
	);

	acl.rule(ActionPermissionEnum.ACTOR_IMPORT_DOWNLOAD, 'Project', (user: UserInfo, project: any) =>
		user &&
		hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_DOWNLOAD, user, project)
	);

	acl.rule(ActionPermissionEnum.IMPORT_DELETE, 'Project', (user: UserInfo, project: any) =>
		user &&
		hasRolesForProject(TechnicalRolesEnum.IMPORTER_DELETE, user, project)
	);

	acl.rule(ActionPermissionEnum.IMPORT_PATIENT_DOWNLOAD, 'Project', (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.IMPORT_REMUNERATION_DOWNLOAD, 'Project', (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(ActionPermissionEnum.IMPORT_UNDUE_DOWNLOAD, 'Project', (user: UserInfo) =>
			user && (
				user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
			)
	);

	acl.rule(ActionPermissionEnum.USER_ACTOR_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.USER_ACTOR_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.USER_ACTOR_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.USER_ACTOR_DELETE, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.USER_ACTOR_EDIT, 'Project', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.USER_ACTOR_EDIT, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.IDEL_ACTOR_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.IDEL_ACTOR_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.IDEL_ACTOR_DELETE, 'Project', (user: UserInfo, project: any) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.IDEL_ACTOR_DELETE, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.EXPORT_PAYMENT_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.EXPORT_PAYMENT_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.SURVEY_CAMPAIGN_EDIT, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.SURVEY_CAMPAIGN_EDIT, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.UNDUE_ADD, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(TechnicalRolesEnum.UNDUE_ADD, user, project)
		)
	);

	acl.rule(ActionPermissionEnum.UNDUE_UPDATE, (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER)
		)
	);

	acl.rule(ActionPermissionEnum.UNDUE_DELETE, (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
		)
	);

	acl.rule(ActionPermissionEnum.IMPORT_CONTROL_FILE_DELETE, 'Project', (user: UserInfo, project: any) =>
		user &&
		hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_DELETE, user, project)
	);

	acl.rule(ActionPermissionEnum.IMPORT_CONTROL_FILE_DOWNLOAD, 'Project', (user: UserInfo, project: any) =>
		user &&
		hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_DOWNLOAD, user, project)
	);

	acl.rule(ActionPermissionEnum.PAYMENT_RECEIPT_GENERATE, 'Project', (user: UserInfo, project: any) =>
		user && (
			hasRolesForProject(BusinessRolesEnum.FINANCIAL_CONTROLLER, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
	)
);

	return acl;
}
